import { EColors, RELATION_BLOCK_WEIGHT } from './constants';

export function getBackgroundColorByRatingSum(value: number) {
  if (value <= 3.499) return EColors.RED;
  else if (value >= 3.5 && value <= 4.499) return EColors.YELLOW;
  else if (value >= 4.5) return EColors.GREEN;
  else return EColors.DEFAULT;
}

// Оценка МО на 5-балльной шкале = вклад блока «Отношение» / вес блока (0.2). Методика v2.
export function getMoMark(relationRating?: number) {
  if (!relationRating) return 0;
  return Math.round((relationRating / RELATION_BLOCK_WEIGHT) * 10) / 10;
}
